import { takeLatest } from 'redux-saga/effects';
import { myQuoteActions } from './myQuoteSlice';
import callSubmitSignatureSaga from './sagas/callSubmitSignatureSaga';
import callFetchQuoteSaga from './sagas/callFetchQuoteSaga';

export default function* myQuoteSaga() {
  yield takeLatest(myQuoteActions.submitSignature, callSubmitSignatureSaga);
  yield takeLatest(myQuoteActions.getQuote, callFetchQuoteSaga);
}
